// Single client-side source for Clean Truck Check status presentation.
// Mirrors the server CtcComplianceStatusEnum severity so web and mobile read alike.

const SEVERITY_MAP = {
    success: {color: 'success', icon: 'mdi-check-circle'},
    warning: {color: 'warning', icon: 'mdi-clock-alert-outline'},
    error: {color: 'error', icon: 'mdi-alert-octagon-outline'},
    info: {color: 'info', icon: 'mdi-progress-clock'},
    neutral: {color: 'grey', icon: 'mdi-minus-circle-outline'},
};

const DEFAULT = {color: 'grey', icon: 'mdi-help-circle-outline'};

export function useCtcStatus() {
    const statusColor = (severity) => (SEVERITY_MAP[severity] ?? DEFAULT).color;
    const statusIcon = (severity) => (SEVERITY_MAP[severity] ?? DEFAULT).icon;

    const deadlineColor = (days) => {
        if (days === null || days === undefined) return 'grey';
        if (days < 0) return 'error';
        if (days <= 14) return 'error';
        if (days <= 30) return 'warning';
        return 'grey-darken-1';
    };

    const deadlineLabel = (days) => {
        if (days === null || days === undefined) return 'No deadline';
        if (days < 0) return `${Math.abs(days)} days overdue`;
        if (days === 0) return 'Due today';
        return `${days} days left`;
    };

    return {statusColor, statusIcon, deadlineColor, deadlineLabel};
}
